import type { Report } from '@eis/core/reporting';

/** One row of the report list (mockup board 2). */
export interface ReportRow {
  readonly id: string;
  readonly code: string;
  readonly name: string;
  readonly reportType: string;
  readonly datasetName: string;
  /** The latest published version (0 = none). */
  readonly publishedVersion: number;
  /** The open draft's number (`published + 1`), or 0 without a draft. */
  readonly draftVersion: number;
  readonly visibility: string;
  readonly author: string;
  readonly updatedAt: string;
}

/** The author as the list shows it: the mock's `user-<persona>` without its prefix, else the subject. */
export function authorOf(id: string | undefined): string {
  return (id ?? '').replace(/^user-/, '');
}

export function toReportRows(items: readonly Report[]): ReportRow[] {
  return items.map((r) => {
    const published = r.publishedVersion ?? 0;
    return {
      id: r.code ?? '',
      code: r.code ?? '',
      name: r.name ?? r.code ?? '',
      reportType: r.reportType ?? '',
      datasetName: r.datasetName ?? '',
      publishedVersion: published,
      draftVersion: r.hasDraft === true ? published + 1 : 0,
      visibility: r.visibility ?? '',
      author: authorOf(r.authorId),
      updatedAt: r.updatedAt ?? '',
    };
  });
}
